export const MersTransferDetailsFormTestIds = {
  FORM: 'mers-transfer-details.form',
  EFFECTIVE_DATE: 'mers-transfer-details.effective-date',
  BENEFICIAL_EFFECTIVE_DATE: 'mers-transfer-details.beneficial-effective-date',
  SALE_DATE: 'mers-transfer-details.sale-date',
  SALE_ID: 'mers-transfer-details.sale-id-input',
  SUBMIT_BUTTON: 'mers-transfer-details.submit-button',
};
